/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */
import React, { Suspense } from 'react';

// oxlint-disable-next-line @atlassian/no-restricted-imports
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

import { withBrandIcon, type BrandIcon } from '../../../icons/with-brand-icon';

const OfficialIcon = lazyForPaint(
	() =>
		import(
			/* webpackChunkName: "@atlassian/logo-third-party/dovetail" */ '@atlassian/logo-third-party/dovetail'
		).then((m) => m.DovetailIcon),
	{ moduleId: '@atlassian/logo-third-party/dovetail' },
);

const LazyDovetailIconComponent = lazyForPaint(
	() => import(/* webpackChunkName: "icon-dovetail" */ './utils').then((m) => m.DovetailIcon),
	{ moduleId: '@atlassian/rovo-connectors-config/dovetail/icon' },
);

const LazyDovetailSearchResultIconComponent = lazyForPaint(
	() =>
		import(/* webpackChunkName: "icon-dovetail-search-result" */ './utils').then(
			(m) => m.DovetailSearchResultIcon,
		),
	{ moduleId: '@atlassian/rovo-connectors-config/dovetail/search-result-icon' },
);

/**
 * Exported icons with self-contained Suspense boundaries.
 * Consumers can use these directly without wrapping in LazySuspense.
 */
export const DovetailIcon: BrandIcon = withBrandIcon(
	(): React.JSX.Element => (
		<Suspense fallback={null}>
			<LazyDovetailIconComponent />
		</Suspense>
	),
	OfficialIcon,
	'small',
);

export const DovetailSearchResultIcon: BrandIcon = withBrandIcon(
	(): React.JSX.Element => (
		<Suspense fallback={null}>
			<LazyDovetailSearchResultIconComponent />
		</Suspense>
	),
	OfficialIcon,
	'medium',
);
